/**
 * Filter drawer for the Customer Products view.
 * Currently only contains the Organizations filter (SUPER_ADMIN only).
 */
import { Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { GraphQL } from "@rpi/openapi-api";
import { FilterDrawer } from "../../components/filters/FilterDrawer";
import { SearchInput } from "../../configuration/filters/searchInput";
import {
  getCustomerPublicIdFilter,
  getInitialOrganization,
  NO_FILTER_VALUE,
  OrganizationFilter,
} from "../../components/filters/OrganizationFilter";
import { useFilterStyles } from "../../components/filters/filterStyles";
import { toSearchInputArray } from "../../configuration/filters/searchInput";

const filterFormId = "customer-product-filter-form";

type CustomerProductFilterProps = {
  filters: SearchInput<GraphQL.CustomerProductSearchField>[];
  onClose: () => void;
  onApply: (filter: SearchInput<GraphQL.CustomerProductSearchField>[]) => void;
};
export function CustomerProductFilter({
  isOpened,
  filters,
  onClose,
  onApply,
}: { isOpened: boolean } & CustomerProductFilterProps) {
  return (
    <FilterDrawer formId={filterFormId} isOpened={isOpened} onClose={onClose}>
      <CustomerProductFilterContent filters={filters} onClose={onClose} onApply={onApply} />
    </FilterDrawer>
  );
}

function CustomerProductFilterContent({ filters: initialFilters, onClose, onApply }: CustomerProductFilterProps) {
  const { classes } = useFilterStyles();

  const { getInputProps, onSubmit, setFieldValue } = useForm({
    initialValues: {
      selectedCustomer: getInitialOrganization(GraphQL.CustomerProductSearchField.CustomerPublicId, initialFilters),
    },
  });

  const handleApply = (customerPublicId: string) => {
    const filters = toSearchInputArray([
      getCustomerPublicIdFilter(GraphQL.CustomerProductSearchField.CustomerPublicId, customerPublicId),
    ]);
    onApply(filters);
    onClose();
  };

  const handleClear = () => {
    setFieldValue("selectedCustomer", NO_FILTER_VALUE);
  };

  return (
    <Stack className={classes.root}>
      <form
        id={filterFormId}
        className={classes.form}
        onSubmit={onSubmit((values) => handleApply(values.selectedCustomer))}
        onReset={handleClear}
      >
        <OrganizationFilter {...getInputProps("selectedCustomer")} />
      </form>
    </Stack>
  );
}
